module.exports = __webpack_public_path__ + "static/img/16_pro.f568df0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/16_pro.jpg
// module id = Y4ZE
// module chunks = 0